import { _ as r } from "./_createBaseFor.js";
var a = r, e = a(), s = e;
export {
  s as _
};
//# sourceMappingURL=_baseFor.js.map
